export default "/images/vendor/flag-icon-css/flags/1x1/rw.svg?be9b568247b778302b3f005ffda10250";